import React, { ComponentType } from 'react';

export default function withCanOpenFile(WrappedComponent: ComponentType<any>) {
  return function (props: Object) {
    const mergedProps = { ...props, overrideCanOpen: true };
    return <WrappedComponent {...mergedProps} />;
  };
}
